var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a1 1 0 000 2h18a1 1 0 100-2H3zm0 4a1 1 0 000 2h18a1 1 0 100-2H3zm-1 5a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zm1 3a1 1 0 100 2h18a1 1 0 100-2H3z",
    fill: "#0D0D0D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDVDMi40NDc3MiA1IDIgNS40NDc3MiAyIDZDMiA2LjU1MjI4IDIuNDQ3NzIgNyAzIDdIMjFDMjEuNTUyMyA3IDIyIDYuNTUyMjggMjIgNkMyMiA1LjQ0NzcyIDIxLjU1MjMgNSAyMSA1SDNaTTMgOUMyLjQ0NzcyIDkgMiA5LjQ0NzcyIDIgMTBDMiAxMC41NTIzIDIuNDQ3NzIgMTEgMyAxMUgyMUMyMS41NTIzIDExIDIyIDEwLjU1MjMgMjIgMTBDMjIgOS40NDc3MiAyMS41NTIzIDkgMjEgOUgzWk0yIDE0QzIgMTMuNDQ3NyAyLjQ0NzcyIDEzIDMgMTNIMjFDMjEuNTUyMyAxMyAyMiAxMy40NDc3IDIyIDE0QzIyIDE0LjU1MjMgMjEuNTUyMyAxNSAyMSAxNUgzQzIuNDQ3NzIgMTUgMiAxNC41NTIzIDIgMTRaTTMgMTdDMi40NDc3MiAxNyAyIDE3LjQ0NzcgMiAxOEMyIDE4LjU1MjMgMi40NDc3MiAxOSAzIDE5SDIxQzIxLjU1MjMgMTkgMjIgMTguNTUyMyAyMiAxOEMyMiAxNy40NDc3IDIxLjU1MjMgMTcgMjEgMTdIM1oiIGZpbGw9IiMwRDBEMEQiLz4KPC9zdmc+Cg==";
export { SvgMenu as ReactComponent };